(function(){
    'use strict';

    angular.module('elogbooks.common.set-password', []);
})();
